/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import changePasswordTemplate from './change-password.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function ProfileController(userService, $scope, $document, $mdDialog, $translate, $state) {
    var vm = this;

    vm.$onInit = function () {
        vm.nsVersion = TEKTELIC_NS_VERSION; //eslint-disable-line
        vm.commitHash = COMMITHASH; //eslint-disable-line
        vm.tag = process.env.GIT_TAG; // eslint-disable-line

        vm.profileUser = {};

        vm.save = save;
        vm.changePassword = changePassword;
        vm.languageList = {
            en_US: {value: "en_US", name: "language.en_US"}
        };

        loadProfile();
    };

    function loadProfile() {
        userService.getUser(userService.getCurrentUser().userId).then(function success(user) {
            vm.profileUser = user;
            vm.profileUser.lang = $translate.use();
        });
    }

    function save() {
        userService.saveUser(vm.profileUser).then(function success(user) {
            $translate.use(vm.profileUser.lang);
            vm.profileUser = user;
            vm.profileUser.lang = $translate.use();
            $scope.theForm.$setPristine();
            userService.refreshJwtToken()
                .then(() => {
                    $state.reload()
                })
        });
    }

    function changePassword($event) {
        $mdDialog.show({
            controller: 'ChangePasswordController',
            controllerAs: 'vm',
            templateUrl: changePasswordTemplate,
            parent: angular.element($document[0].body),
            fullscreen: true,
            targetEvent: $event
        }).then(function () {
        }, function () {
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/profile/profile.controller.js